import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

/**
 * MSAL Angular can protect routes in your application
 * using MsalGuard. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#secure-the-routes-in-your-application
 */
const routes: Routes = [
  {
    path: '', loadChildren: () => import('./main-layout/main-layout.module').then(m => m.MainLayoutModule), canActivate: [ MsalGuard ] },
  { path: 'warming', loadChildren: () => import('./warming/warming.module').then(m => m.WarmingModule), canActivate: [MsalGuard] }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? "enabledBlocking" : "disabled"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
